export default {
  // getCity: '/v3/cities/queryCitiesByParentId',
  getCity: '/gateway/courier/cities/queryCitiesByParentId/list',
  submitCity: '/v3/recruit/receive/address/saveOrUpdate'
}
